import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/components/utils/useLanguage';

export default function ActivityRichText({ activity }) {
  const { language } = useLanguage();
  const navigate = useNavigate();

  if (!(activity.content_de?.length > 0 || activity.content_en?.length > 0)) return null;

  return (
    <div
      className="text-[20px] leading-[150%] rich-text"
      dangerouslySetInnerHTML={{
        __html: language === 'en' ? activity.content_en || activity.content_de : activity.content_de
      }}
      onClick={(e) => {
        const a = e.target.closest('a');
        if (!a) return;
        const href = a.getAttribute('href');
        if (!href) return;
        // Stored content holds raw anchors, so route them through the app instead
        // of reloading the page. Activity links are the two-segment
        // /<category-slug>/<activity-slug> form.
        if (!/^\/[^/?#]+\/[^/?#]+$/.test(href)) return;
        e.preventDefault();
        navigate(href);
        window.scrollTo(0, 0);
      }}
    />
  );
}